import { useRef, useState, useMemo } from 'react';
import Portal from '../../../../../components/other/portal';
import Select from 'react-select';
import './styles.scss';
import DatePicker from 'react-datepicker';
import { DATE_PICKER_DATE_FORMAT } from '../../../../../constants';
import ColorPicker from '../../../../../components/other/color-picker';
import { SCHEDULING_HOURS_OPTIONS, SCHEDULING_MINUTES_OPTIONS } from '../../../../../constants';
import SelectWithOtherOption from '../../../../../components/other/select-with-other-option';

const EditSidebar = ({
  handleClose,
  employees,
  setSelectedUser,
  selectedUser,
  sidebarAction,
  setSidebarAction,
  formData,
  setFormData,
  handleSave,
  handleDelete,
  isSavingUser,
  editSidebarSelectedItems,
  setEditSidebarSelectedItems,
  handleOffDueEditSidebar,
}) => {
  const ref = useRef(null);

  const employeesOptions = employees.map((employee) => ({ ...employee, value: employee.id, label: employee.full_name }));

  const groupedSelectedItemsByDay = useMemo(() => {
    const groupedSelectedItemsByDay = {};

    editSidebarSelectedItems.forEach((shift) => {
      const date = new Date(shift.cell.day);

      const formatted = date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
      });

      const weekday = date.toLocaleDateString('en-US', {
        weekday: 'long',
      });

      const day = `${formatted} ${weekday}`;

      if (!groupedSelectedItemsByDay[day]) {
        groupedSelectedItemsByDay[day] = [];
      }
      groupedSelectedItemsByDay[day].push(shift);
    });

    return groupedSelectedItemsByDay;
  }, [editSidebarSelectedItems]);

  return (
    <Portal>
      <div className="schedule-sidebar" ref={ref}>
        <div className="schedule-sidebar-header">
          <div className="schedule-sidebar-header-title-wrapper">
            {(!sidebarAction || sidebarAction === 'add') && (
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="32" height="32" rx="16" fill="#F4EBFF" />
                <rect x="2" y="2" width="32" height="32" rx="16" stroke="#F9F5FF" strokeWidth="4" />
                <g clipPath="url(#clip0_15946_19394)">
                  <path
                    d="M17.334 12.6671H12.6673C12.3137 12.6671 11.9746 12.8076 11.7245 13.0577C11.4745 13.3077 11.334 13.6469 11.334 14.0005V23.3338C11.334 23.6874 11.4745 24.0266 11.7245 24.2766C11.9746 24.5267 12.3137 24.6671 12.6673 24.6671H22.0007C22.3543 24.6671 22.6934 24.5267 22.9435 24.2766C23.1935 24.0266 23.334 23.6874 23.334 23.3338V18.6671M22.334 11.6671C22.5992 11.4019 22.9589 11.2529 23.334 11.2529C23.7091 11.2529 24.0688 11.4019 24.334 11.6671C24.5992 11.9324 24.7482 12.2921 24.7482 12.6671C24.7482 13.0422 24.5992 13.4019 24.334 13.6671L18.0007 20.0005L15.334 20.6671L16.0007 18.0005L22.334 11.6671Z"
                    stroke="#7F56D9"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15946_19394">
                    <rect width="16" height="16" fill="white" transform="translate(10 10)" />
                  </clipPath>
                </defs>
              </svg>
            )}
            {sidebarAction === 'delete' && (
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="38" height="38" rx="19" fill="#FEE4E2" />
                <rect x="5" y="5" width="38" height="38" rx="19" stroke="#FFF2F1" strokeWidth="10" />
                <path
                  d="M16.5 19.0003H18.1667M18.1667 19.0003H31.5M18.1667 19.0003V30.667C18.1667 31.109 18.3423 31.5329 18.6548 31.8455C18.9674 32.1581 19.3913 32.3337 19.8333 32.3337H28.1667C28.6087 32.3337 29.0326 32.1581 29.3452 31.8455C29.6577 31.5329 29.8333 31.109 29.8333 30.667V19.0003H18.1667ZM20.6667 19.0003V17.3337C20.6667 16.8916 20.8423 16.4677 21.1548 16.1551C21.4674 15.8426 21.8913 15.667 22.3333 15.667H25.6667C26.1087 15.667 26.5326 15.8426 26.8452 16.1551C27.1577 16.4677 27.3333 16.8916 27.3333 17.3337V19.0003M22.3333 23.167V28.167M25.6667 23.167V28.167"
                  stroke="#B42318"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            {sidebarAction === 'off_due_to' && (
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="38" height="38" rx="19" fill="#FEE4E2" />
                <rect x="5" y="5" width="38" height="38" rx="19" stroke="#FFF2F1" strokeWidth="10" />
                <path
                  d="M26.8441 17.5996V20.2663M21.1552 17.5996V20.2663M17.5996 22.9329H30.3996M26.1329 24.933L23.9996 26.933M23.9996 26.933L21.8663 28.933M23.9996 26.933L21.8663 24.933M23.9996 26.933L26.1329 28.933M19.0218 18.9329H28.9774C29.7629 18.9329 30.3996 19.5299 30.3996 20.2663V29.5996C30.3996 30.336 29.7629 30.9329 28.9774 30.9329H19.0218C18.2364 30.9329 17.5996 30.336 17.5996 29.5996V20.2663C17.5996 19.5299 18.2364 18.9329 19.0218 18.9329Z"
                  stroke="#B42318"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            {!sidebarAction && 'Edit'}
            {sidebarAction === 'add' && 'Add'}
            {sidebarAction === 'off_due_to' && 'Off due to'}
            {sidebarAction === 'delete' && 'Delete'}
          </div>
          <button className="btn btn-icon" onClick={handleClose}>
            <i className="icon-icon-x"></i>
          </button>
        </div>
        <div className="schedule-sidebar-body">
          <div className="schedule-form">
            <div className="form-item">
              <label className="form-label">Name Last Name</label>
              <div className="sidebar-name-select-wrapper">
                <Select
                  isSearchable
                  options={employeesOptions}
                  className="form-control-select"
                  classNamePrefix="react-select"
                  value={selectedUser}
                  placeholder="Select employee"
                  onChange={(e) => setSelectedUser(e)}
                />
              </div>
            </div>

            {sidebarAction === 'add' && (
              <>
                <div className="form-item">
                  <label className="form-label">Full or part shift</label>
                  <div className="sidebar-name-select-wrapper">
                    <Select
                      isSearchable={false}
                      options={[
                        { value: 'both_halves', label: 'Full shift' },
                        { value: 'first_half', label: 'First half' },
                        { value: 'second_half', label: 'Second half' },
                      ]}
                      className="form-control-select"
                      classNamePrefix="react-select"
                      value={formData.halfPart}
                      onChange={(e) => setFormData((state) => ({ ...state, halfPart: e }))}
                    />
                  </div>
                </div>

                <div className="form-items-wrapper">
                  <div className="form-item">
                    <label className="form-label">Working hours</label>
                    <Select
                      isSearchable={false}
                      options={SCHEDULING_HOURS_OPTIONS}
                      className="form-control-select"
                      classNamePrefix="react-select"
                      placeholder="Working hours"
                      filterOption={null}
                      value={formData.hours}
                      onChange={(e) => setFormData((state) => ({ ...state, hours: e }))}
                    />
                  </div>
                  <div className="form-item">
                    <label className="form-label">Minutes</label>
                    <Select
                      isSearchable={false}
                      options={SCHEDULING_MINUTES_OPTIONS}
                      className="form-control-select"
                      classNamePrefix="react-select"
                      placeholder="Minutes"
                      filterOption={null}
                      value={formData.minutes}
                      onChange={(e) => setFormData((state) => ({ ...state, minutes: e }))}
                    />
                  </div>
                </div>

                <div className="form-item form-color-wrapper">
                  <div className="form-font-color">
                    <ColorPicker
                      color={formData.fontColor}
                      onChange={(color) => setFormData((state) => ({ ...state, fontColor: color.hex }))}
                      label="Font color"
                      pickerWidth="342px"
                    />
                  </div>
                  <div className="form-font-color">
                    <ColorPicker
                      color={formData.cellColor}
                      onChange={(color) => setFormData((state) => ({ ...state, cellColor: color.hex }))}
                      label="Cell color"
                      pickerWidth="342px"
                    />
                  </div>
                </div>

                <div className="form-item">
                  <label className="form-label">Notes (optional)</label>
                  <input
                    name="notes"
                    type="text"
                    className="form-control"
                    placeholder="Enter"
                    value={formData.notes}
                    onChange={(e) => setFormData((state) => ({ ...state, notes: e.target.value }))}
                  />
                </div>
              </>
            )}

            {sidebarAction === 'off_due_to' && (
              <>
                <div className="form-item">
                  <label className="form-label">Off due to</label>
                  <div className="sidebar-name-select-wrapper">
                    <SelectWithOtherOption
                      options={[
                        { value: 'pto', label: 'PTO' },
                        { value: 'call_off', label: 'Call off' },
                        { value: 'other', label: 'Other' },
                      ]}
                      selectedOption={formData.offDueTo}
                      setFormData={setFormData}
                      placeholder={'Reason'}
                      formKey={'offDueTo'}
                    />
                  </div>
                </div>
              </>
            )}

            {editSidebarSelectedItems.length > 0 ? (
              <div className="selected-items-list">
                {Object.keys(groupedSelectedItemsByDay).map((day) => (
                  <div className="selected-items-list-item" key={day}>
                    <div className="selected-items-list-item-name-wrapper">
                      <div className="selected-items-list-item-name">{day}</div>
                    </div>
                    <div className="selected-items-list-item-shift">
                      {groupedSelectedItemsByDay[day].map((shift) => (
                        <div className="selected-items-list-item-cell-wrapper" key={shift.cell.id}>
                          <div className="selected-items-cell-item-left-block">
                            {shift.unitName}, <strong>{shift.roleName}</strong>
                          </div>
                          <div className="selected-items-cell-item-center-block">
                            shift {shift.shiftName}{' '}
                            {shift.halfPart == 'first_half' ? '/ 1st half' : shift.halfPart == 'second_half' ? '/ 2nd half' : ''}
                          </div>
                          <div className="selected-items-cell-item-right-block">
                            <button
                              className="selected-items-cell-item-delete-btn"
                              onClick={() =>
                                setEditSidebarSelectedItems((prevState) =>
                                  prevState.filter((item) => !(item.cell.id === shift.cell.id && item.halfPart === shift.halfPart)),
                                )
                              }
                            >
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M10.0007 5.99967L6.00065 9.99967M6.00065 5.99967L10.0007 9.99967M14.6673 7.99967C14.6673 11.6816 11.6825 14.6663 8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6825 1.33301 14.6673 4.31778 14.6673 7.99967Z"
                                  stroke="#DADEE4"
                                  strokeWidth="1.67"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {sidebarAction && (
                  <div className={`edit-sidebar-warning-wrapper ${sidebarAction}`}>
                    {sidebarAction === 'delete' && (
                      <>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.3327 13.667L10.3327 10.3337M10.3327 7.00032H10.3243M1.99935 10.3337C1.99935 5.73128 5.73031 2.00032 10.3327 2.00032C14.9351 2.00032 18.666 5.73128 18.666 10.3337C18.666 14.936 14.9351 18.667 10.3327 18.667C5.73031 18.667 1.99935 14.936 1.99935 10.3337Z"
                            stroke="#B42318"
                            strokeWidth="1.67"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <p className="delete-message">Select one or more highlighted shifts to delete them.</p>
                      </>
                    )}

                    {sidebarAction === 'add' && (
                      <>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.3327 13.667L10.3327 10.3337M10.3327 7.00032H10.3243M1.99935 10.3337C1.99935 5.73128 5.73031 2.00032 10.3327 2.00032C14.9351 2.00032 18.666 5.73128 18.666 10.3337C18.666 14.936 14.9351 18.667 10.3327 18.667C5.73031 18.667 1.99935 14.936 1.99935 10.3337Z"
                            stroke="#6941C6"
                            strokeWidth="1.67"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <p className="add-message">
                          Сlick on available cells to add single shifts to the current and future 2-week periods.
                        </p>
                      </>
                    )}

                    {sidebarAction === 'off_due_to' && (
                      <>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.3327 13.667L10.3327 10.3337M10.3327 7.00032H10.3243M1.99935 10.3337C1.99935 5.73128 5.73031 2.00032 10.3327 2.00032C14.9351 2.00032 18.666 5.73128 18.666 10.3337C18.666 14.936 14.9351 18.667 10.3327 18.667C5.73031 18.667 1.99935 14.936 1.99935 10.3337Z"
                            stroke="#B42318"
                            strokeWidth="1.67"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <p className="off-due-message">Select one or more highlighted shifts</p>
                      </>
                    )}
                  </div>
                )}
              </>
            )}

            {sidebarAction ? (
              <div className="bottom-buttons">
                <button className="btn btn-outline" onClick={handleClose}>
                  Cancel
                </button>
                {sidebarAction === 'add' && (
                  <button
                    className="btn "
                    onClick={handleSave}
                    disabled={!selectedUser || !formData.halfPart || !editSidebarSelectedItems.length || isSavingUser}
                  >
                    {isSavingUser ? 'Saving...' : 'Save'}
                  </button>
                )}
                {sidebarAction === 'delete' && (
                  <button className="btn btn-danger" onClick={handleDelete} disabled={!editSidebarSelectedItems.length || isSavingUser}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2.5 4.99935H4.16667M4.16667 4.99935H17.5M4.16667 4.99935V16.666C4.16667 17.108 4.34226 17.532 4.65482 17.8445C4.96738 18.1571 5.39131 18.3327 5.83333 18.3327H14.1667C14.6087 18.3327 15.0326 18.1571 15.3452 17.8445C15.6577 17.532 15.8333 17.108 15.8333 16.666V4.99935H4.16667ZM6.66667 4.99935V3.33268C6.66667 2.89065 6.84226 2.46673 7.15482 2.15417C7.46738 1.84161 7.89131 1.66602 8.33333 1.66602H11.6667C12.1087 1.66602 12.5326 1.84161 12.8452 2.15417C13.1577 2.46673 13.3333 2.89065 13.3333 3.33268V4.99935M8.33333 9.16602V14.166M11.6667 9.16602V14.166"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Delete
                  </button>
                )}
                {sidebarAction === 'off_due_to' && (
                  <button
                    className="btn "
                    onClick={handleOffDueEditSidebar}
                    disabled={!selectedUser || !editSidebarSelectedItems.length || isSavingUser}
                  >
                    {isSavingUser ? 'Saving...' : 'Save'}
                  </button>
                )}
              </div>
            ) : (
              <div className="bottom-buttons">
                <button className="btn btn-outline user-add-btn" onClick={() => setSidebarAction('add')} disabled={!selectedUser}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 3V17M3 10H17" stroke="#7F56D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Add
                </button>
                <button
                  className="btn btn-outline user-off-due-btn"
                  onClick={() => setSidebarAction('off_due_to')}
                  disabled={!selectedUser}
                >
                  Off due to
                </button>
                <button className="btn user-delete-btn" onClick={() => setSidebarAction('delete')} disabled={!selectedUser}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.5 5.00033H4.16667M4.16667 5.00033H17.5M4.16667 5.00033V16.667C4.16667 17.109 4.34226 17.5329 4.65482 17.8455C4.96738 18.1581 5.39131 18.3337 5.83333 18.3337H14.1667C14.6087 18.3337 15.0326 18.1581 15.3452 17.8455C15.6577 17.5329 15.8333 17.109 15.8333 16.667V5.00033H4.16667ZM6.66667 5.00033V3.33366C6.66667 2.89163 6.84226 2.46771 7.15482 2.15515C7.46738 1.84259 7.89131 1.66699 8.33333 1.66699H11.6667C12.1087 1.66699 12.5326 1.84259 12.8452 2.15515C13.1577 2.46771 13.3333 2.89163 13.3333 3.33366V5.00033M8.33333 9.16699V14.167M11.6667 9.16699V14.167"
                      stroke="white"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default EditSidebar;
